import i18next from "i18next";
import { Component } from "react"
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import GiroService, { MakePaymentValues } from "../../services/GiroService";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { GiroListColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import { DKLabel,DKCalendar, DKLine, DKIcon, TOAST_TYPE, DKButton, DKInput, showToast, showLoader, removeLoader, INPUT_VIEW_DIRECTION} from "deskera-ui-library";
import Utility from "../../utility/Utility";
import { FORMAT } from "../../constants/Constant";
import moment from "moment";
import calender from '../../assets/icons/white/date_range.svg';
import {  MODULE } from "../user-permissions/PermissionUtils";
export default class GiroGrid extends Component {

    grid = {
        gridActions: {
            filters: [],
            currentPage: 1,
            totalPageCount: 1
        },
        gridData: {
            columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_GIRO), TABLES.PEOPLE_GIRO)),
            rowData: [],
            filter: [],
            originalData: []
        },
        canValidate: false
    }
    
    constructor(props) {
        super(props)
        RouteManager.setPresenter(this);
        GiroService.MakePaymentValues = GiroService.defaultMakePaymentValues;
        this.getGIROList()
    }
    componentDidMount() {
        this.updateState()
    }
    updateState() {
        this.setState({...this.state})
    }
    selection;
    selectYear = {
        toggle: false,
        startDate: moment(moment().format()).startOf('month'),
        endDate: moment(moment().format()).endOf('month'),
        defaultDate:false,
        hasError: false,
        errorMsg:'End date should not be less than Start date'
    }
    getGIROList() {
        let params = {
            limit: 20,
            currentPage: 1,
            from: moment(moment(this.selectYear.startDate).format()).format('MM/DD/YYYY'),
            to: moment(moment(this.selectYear.endDate).format()).format('MM/DD/YYYY')
        }
        showLoader()
        GiroService.getGiroList(params).then(res=>{
            removeLoader()
            if(res && res.payrunForGIROFile) {
                this.grid.gridData.rowData = GiroListColumnConfig(res.payrunForGIROFile);
                this.updateState()
            } else {
                this.grid.gridData.rowData = [];
                this.updateState()
            }
        },error=>{
            removeLoader()
        })
    }
    onRowAdd = () => { }
    onRowDelete = () => { }
    onContextCancel = () => { }
    onRowClick = () => { }
    getAttendanceData = () => { }
    onSearch = () => { }
    makePayment = (data) => { 
        console.log(data); 
        if(data.rowData.data) {
            let payrun = data.rowData.data
            GiroService.MakePaymentValues = {
                payrunId: payrun.payrunId,
                totalCost: payrun.netPay ? payrun.netPay : 0,
                firstPayDate:payrun.firstPayDate,
                backRout: PAGE_ROUTES.GIRO
            }
            RouteManager.navigateToPage(PAGE_ROUTES.GIRO_MAKE_PAYMENT+'/1');
        
        }        
    }
    filterCalenderButton = () => {
        return (
            <>
                {/*
                // Note: This willl use later //

                <div className="row  ml-o">
                    <div className="column">
                        <DKButton
                            className="bg-app text-white mr-r team-report-date"
                            icon={calender}
                            title={(this.selectYear.startDate != '' && this.selectYear.endDate != '') ? `${Utility.formatDate(moment(this.selectYear.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(this.selectYear.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}` : `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`}
                            onClick={(value) => {
                                this.selectYear={
                                    toggle: (this.selectYear.toggle) ? false : true,
                                    startDate: this.selectYear.startDate,
                                    endDate: this.selectYear.endDate,
                                    defaultDate: true
                                }
                                this.updateState()
                            }}
                        />

                    </div>

                </div> */}
                {this.selectYear.hasError && <DKLabel className="text-red" text={this.selectYear.errorMsg} />}
                <div className="">
                    {this.selectYear.toggle && (
                        <DKCalendar
                            className="position-absolute border-m shadow-m bg-white z-index-6 mt-s calender-filter"
                            isDateRange={true}
                            startDate={this.selectYear.startDate ? new Date(this.selectYear.startDate) : new Date()}
                            endDate={this.selectYear.endDate ? new Date(this.selectYear.endDate) : new Date()}
                            onClose={() => {
                                if (moment(this.selectYear.startDate).diff(this.selectYear.endDate) <= 0 || this.selectYear.endDate == null) {
                                    this.selectYear={
                                        toggle: false,
                                        startDate: this.selectYear.startDate,
                                        endDate: this.selectYear.endDate,
                                        defaultDate: false,
                                        hasError: false
                                    };
                                } else {
                                    this.selectYear={
                                        toggle: false,
                                        startDate: this.selectYear.startDate,
                                        endDate: this.selectYear.endDate,
                                        defaultDate: false,
                                        hasError: true,
                                        errorMsg: "End date should not be less than Start date"
                                    };
                                }
                                this.updateState()
                            }}
                            onSelectDate={(start, end) => {
                                if (start && end) {
                                    let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                                    let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                                    if (moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                        this.selectYear ={
                                            toggle: false,
                                            startDate: startDate,
                                            endDate: endDate,
                                            defaultDate: false,
                                            hasError: false
                                        };
                                        this.getGIROList()
                                    } else {
                                        this.selectYear={
                                            toggle: false,
                                            startDate: startDate,
                                            endDate: endDate,
                                            defaultDate: false,
                                            hasError: true,
                                            errorMsg: "End date should not be less than Start date"
                                        };
                                    }
                                    this.updateState()
                                }
                                // 
                            }}

                        />
                    )}
                </div>

            </>
        )
    }
    getGiroGrid = () => {
        return (
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_GIRO}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_GIRO]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[
                            {
                                title: (this.selectYear.startDate != '' && this.selectYear.endDate != '') ? `${Utility.formatDate(moment(this.selectYear.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(this.selectYear.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}` : `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`,
                                icon:calender,
                                className: "bg-app text-white ml-s",
                                onClick: () => {
                                    this.selectYear={
                                        toggle: (this.selectYear.toggle) ? false : true,
                                        startDate: this.selectYear.startDate,
                                        endDate: this.selectYear.endDate,
                                        defaultDate: true
                                    }
                                    this.updateState()
                                },
                              }
                        ]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                            this.selection = (selection);
                        }}
                        isActionEnabled={true}

                        allowBulkOperation={true}
                        dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            this.onContextCancel();
                        }}
                        contextMenu={false}
                        onRowClick={(data) => {
                            this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            this.grid.gridActions.currentPage = requestedPageNumber
                            this.getAttendanceData()
                        }}
                        onSearch={(data) => this.onSearch(data)}
                        makePayment={this.makePayment}
                        isMenuVisible={false}
                        module={MODULE.GIRO}
                    />
                </div>
            </div>
        )
    }
    render() {
        return (
            <>
                {this.filterCalenderButton()}
                {this.getGiroGrid()}
            </>
        )
    }
}
